import React, { Component } from 'react'
import Link from 'components/UI/Link'
import { routePath } from 'routes'
import { CheckIcon } from 'components/icons'
import { ContentBlock } from 'components/common'
import { Title, Description, Buttons, TipList, WelcomeWrap } from './styles'
import { AppState, Dispatch } from '../../store/types'
import { bindActionCreators } from 'redux'
import { createAccount } from '../../ducks/auth/operations'
import {
  fetchConfiguration,
  fetchConfigurationLogo,
  fetchConfigurationLogoHeader
} from '../../ducks/references/operations'
import { connect } from 'react-redux'
import ROUTES_PATH from '../../routes/routePath'
import LogoTip from '../../components/UI/LogoTip/index.js'

class EstimatesStartPage extends Component<EstimatesStartPageProps> {
  render() {
    const { isAuthenticated } = this.props
    return (
      <ContentBlock isCentered={true}>
        {!isAuthenticated && <LogoTip />}
        <WelcomeWrap>
          {isAuthenticated ? (
            <Title>Getting Started</Title>
          ) : (
            <Title>Welcome to the Patient Estimator</Title>
          )}
          <Description>
            You will need the following information to complete the estimate.
          </Description>
          <TipList>
            <li>
              <CheckIcon />
              Insurance Information
            </li>
            <li>
              <CheckIcon />
              Patient Information
            </li>
            <li>
              <CheckIcon />
              Procedure Information
            </li>
          </TipList>
          {isAuthenticated ? (
            <Buttons>
              <Link variant={'default'} to={routePath.ESTIMATE_CREATE}>
                Get Started
              </Link>
              <Link variant={'secondary'} to={routePath.ESTIMATES_PAGE}>
                Go Back
              </Link>
            </Buttons>
          ) : (
            <Buttons>
              <Link variant={'default'} to={routePath.ESTIMATE_CREATION_BY_EMAIL}>
                Get Started
              </Link>
            </Buttons>

          )}
          <Description>
              Estimation provided is not a guarantee of your costs or benefits.
              Your actual costs may vary based on several factors. This is a
              hospital estimate only and does not include any physician charges.
          </Description>
        </WelcomeWrap>
      </ContentBlock>
    )
  }
}

// export default EstimatesStartPage

const mapStateToProps = (state: AppState) => ({
  isAuthenticated: state.auth.isAuthenticated
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    { createAccount, fetchConfiguration, fetchConfigurationLogo, fetchConfigurationLogoHeader },
    dispatch
  )

interface EstimatesStartPageProps {
  isAuthenticated: boolean
}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps & DispatchProps & EstimatesStartPageProps

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EstimatesStartPage)
